export default __webpack_public_path__ + "static/thirdplace-icon-2-f84228761637f3a5e3695b9bbb1fb7ac.png";